"use client";

import useTranslations from "@/i18n/useTranslations";
import { localizeFaqTitle } from "./localizeFaqTitle";

type LocalizedTitleProps = {
  title: string;
  as?: "h2" | "h3";
  className?: string;
  id?: string;
  children?: never;
};

/**
 * Renders an accordion section title, swapping the common English FAQ
 * heading for the localized Common.frequentlyAskedQuestions string when
 * Spanish twins still carry the untranslated shortcode attr.
 */
export default function LocalizedTitle({
  title,
  as: Tag = "h2",
  className,
  id,
}: LocalizedTitleProps) {
  const t = useTranslations("Common");
  const displayTitle = localizeFaqTitle(title, t("frequentlyAskedQuestions"));

  return (
    <Tag id={id || undefined} className={className}>
      {displayTitle}
    </Tag>
  );
}
